import { OptionType } from '@evinced-private/ui-common';

import { LABEL_DELIMITER } from 'src/common/consts/platformConfigConsts';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

import { buildDisplayNameToKeyMap, buildKeyToDisplayNameMap } from '../../helpers/helpers';
import { TestRowSharedType } from '../../helpers/types';

export const extractExistingLabelsForUpdate = (
	testRows: TestRowSharedType[],
	tenantConfiguredLabels: ConfigurationLabel[]
): OptionType[] => {
	if (!testRows?.length || !tenantConfiguredLabels?.length) {
		return [];
	}

	const displayNameMap = buildDisplayNameToKeyMap(tenantConfiguredLabels);
	const keyToDisplayNameMap = buildKeyToDisplayNameMap(tenantConfiguredLabels);
	const labelKeys = tenantConfiguredLabels.map(({ label }) => label.toLowerCase());

	// Get all unique labels from test rows that match configured labels
	const uniqueLabels = new Set<string>();
	testRows.forEach((row) => {
		const labels = row?.labels ?? [];
		labels.forEach((label: string) => {
			const colonIndex = label.indexOf(':');
			if (colonIndex > 0) {
				const key = label.substring(0, colonIndex).trim().toLowerCase();
				const normalizedKey = displayNameMap.get(key) || key;
				if (labelKeys.includes(normalizedKey)) {
					uniqueLabels.add(label);
				}
			}
		});
	});

	return Array.from(uniqueLabels)
		.map((label) => {
			const parts = label.split(LABEL_DELIMITER);
			if (parts.length > 1) {
				const key = parts[0].trim().toLowerCase();
				const normalizedKey = displayNameMap.get(key) || key;
				const displayName = keyToDisplayNameMap.get(normalizedKey) || parts[0].trim();
				const value = parts.slice(1).join(LABEL_DELIMITER).trim();
				return {
					value: label,
					label: `${displayName}: ${value}`
				};
			}
			return {
				value: label,
				label
			};
		})
		.sort((a, b) => a.label.localeCompare(b.label));
};
